import React from "react";

import { Image } from "semantic-ui-react";

import CheckInLayout from "./CheckInLayout";

import "./AppTodayAppointment.css";

// ======================= Constants =======================
const IMAGES = {
  iconCalendar: "/static/images/checkin/icon-calendar.png",
  iconPhoneHeart: "/static/images/checkin/icon-phone-heart.png",
};

// ======================= Component =======================
const NoAppPKList = () => (
  <CheckInLayout>
    <div className="appointment-content">
      <div className="appointment-icon-bg">
        <Image src={IMAGES.iconCalendar} style={{ width: "5rem", height: "5rem" }} />
      </div>

      <div style={{ fontWeight: 700, fontSize: "2.5rem", color: "#5D5D5D" }}>
        ไม่พบรายการนัดหมาย
      </div>

      <div className="appointment-message-box">
        <div className="appointment-phone-icon-bg">
          <Image src={IMAGES.iconPhoneHeart} className="appointment-phone-icon" />
        </div>
        <div style={{ flex: 1, textAlign: "center" }}>
          <div style={{ color: "rgba(168, 91, 111, 1)", fontSize: "2rem" }}>
            กรุณา{" "}
            <span style={{ fontWeight: 700, color: "rgba(229, 67, 110, 1)" }}>
              เลือกรายการแพ็กเกจ
            </span>{" "}
            ที่ต้องการ
          </div>
          <div style={{ fontSize: "2rem", marginTop: "3rem" }}>
            กด{" "}
            <span
              style={{
                fontWeight: 700,
                color: "rgba(229, 67, 110, 1)",
                textDecoration: "underline",
              }}
            >
              ยืนยันรับบริการ
            </span>{" "}
            บนมือถือ
          </div>
        </div>
      </div>

      <div style={{ color: "#787878", fontSize: "1.25rem" }}>
        --- กำลังรอการยืนยันรับบริการจากคุณ ---
      </div>
    </div>
  </CheckInLayout>
);

NoAppPKList.displayName = "NoAppPKList";

export default NoAppPKList;
